<template>
  <div class="page px-5">
    <page-layout>
      <h3
        slot="header"
        class="my-4 text-truncate"
      >
        <span class="d-none d-lg-inline">Manage</span>&nbsp;Identity Resources
      </h3>
      <b-button
        slot="header"
        size="sm"
        variant="primary"
        @click="addIdentityResource()"
      >
        <i class="fa fa-plus" />
        <span class="d-none d-lg-inline-block">&nbsp; ADD IDENTITY RESOURCE</span>
      </b-button>
      <identity-resource-list />
    </page-layout>
  </div>
</template>

<script>
import PageLayout from "@/components/shared/PageLayout.vue";
import IdentityResourceList from "@/components/identityResources/IdentityResourceList.vue";

export default {
  components: {
    PageLayout,
    IdentityResourceList
  },
  methods: {
    addIdentityResource() {
      this.$router.push({ path: `identityResources/new` });
    }
  }
};
</script>
